<div class="overview-content tab overview-tab" [ngClass]="overviewLayout()">
    @if (isLoading()) {
        <app-loading-spinner [placeholder]="'Loading data...'" [isOverlay]="true"></app-loading-spinner>
    } @else {
        @for (widget of overviewWidgets(); track $index) {
            @switch (widget.type) {
                @case (widgetType.Box) {
                    <app-report-boxes-wrapper
                        [gridArea]="widget.layoutTemplateArea"
                        [boxesValues]="widget.boxesData ?? []"
                    ></app-report-boxes-wrapper>
                }

                @case (widgetType.Metrics) {
                    @if (widget.metricsData) {
                        <div class="metrics-widget" [style.grid-area]="widget.layoutTemplateArea">
                            <app-table [settings]="metricsConfig()" [metricValues]="widget.metricsData"></app-table>
                        </div>
                    }
                }

                @case (widgetType.Chart) {
                    @if (widget.chartData) {
                        <div class="chart-widget" [style.grid-area]="widget.layoutTemplateArea">
                            <app-chart [settings]="widget.settings" [chartValues]="widget.chartData"></app-chart>
                        </div>
                    }
                }
            }
        }
    }
</div>
